<template>
<body class="white-bg">
    <div class="research">
       <div id="complete" class="ibox page-full">
          <div class="r-header">
             {{headerText}}
          </div>
          <div class="r-box page-middle no-borders">
             <div class="text-center mb-4 r-notice" style="padding: 10px 0px;">
                <div style="font-size: 20px;">
                   <span v-html="completeText"></span>
                </div>
             </div>
          </div>
       </div>
    </div>
 </body>
</template>

<script>
//import Service from '@/services/NominateService'

export default {
  name: 'home',
  data() {
    return {
       headerText: null,
        completeText: null,
    }
  },
  mounted() {
      window.scrollTo(0, 0)

      this.headerText = "후보 추천"
      this.completeText = "후보 추천이<br/>완료 되었습니다.<br/><br/>"
         + "감사합니다."
  },
  methods: {
      
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
